import React from "react";
import { ShipmentsService } from "../../services/shipment-service/shipments";
import { ToastContainer, toast } from "react-toastify";
import { Button } from "reactstrap";
import { callErrorToast } from "../../utilities";
import { useAppContext } from "../../AppProvider";

const shipmentsService = new ShipmentsService();

const Delete = ({ id, callback }) => {
  const { dictionary } = useAppContext();

  const deleteShipment = () => {
    shipmentsService
      .delete(id)
      .then((response) => {
        if (callback) {
          callback(true);
        }
        toast.success(dictionary.shipments.shipment_deleted_correctly, {
          position: toast.POSITION.TOP_CENTER,
        });
      })
      .catch((err) => {
        callErrorToast(err, dictionary);
      });
  };

  return (
    <React.Fragment>
      <div className="row mb-3">
        <div className="col">
          <label>{dictionary.messages.ask_to_delete}</label>
        </div>
      </div>
      <div className="d-flex justify-content-end">
        <button
          className="btn btn-link"
          onClick={() => {
            if (callback) {
              callback(false);
            }
          }}
        >
          {dictionary.actions.cancel}
        </button>
        <Button className="btn btn-danger ms-3" onClick={deleteShipment}>
          {dictionary.actions.delete}
        </Button>
      </div>
    </React.Fragment>
  );
};

export default Delete;
